import { useActor } from '@xstate/react';
import type { InterpreterFrom } from 'xstate';
import { CreditCardDetails } from '../../features/credit-card/CreditCardDetails';
import type { paymentDetailsPageMachine } from '../payment-details-page.machine';
import { FlatCard } from '../../components';
import { PAGE } from '~/subscription-management/utils/tracking';

interface Props {
  paymentDetailsMachineService: InterpreterFrom<typeof paymentDetailsPageMachine>;
}

export function PaymentEdit({ paymentDetailsMachineService }: Props): JSX.Element {
  const [state, send] = useActor(paymentDetailsMachineService);

  return (
    <FlatCard>
      <CreditCardDetails
        countryCode={state.context.customer?.billingAddress?.country}
        onSuccess={(vaultedResponse) => {
          send({ type: 'SET_PAYMENT_METHOD', paymentMethodId: vaultedResponse.refId });
        }}
        uiPosition={PAGE.payment}
        accountId={state.context.accountId}
      />
    </FlatCard>
  );
}
